var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loader.show),expression:"loader.show"}],staticClass:"loader"},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-loader-container"},[_c('div',{staticClass:"component-loader-dot"}),_c('div',{staticClass:"component-loader-dot"}),_c('div',{staticClass:"component-loader-dot"}),_c('div',{staticClass:"component-loader-dot"}),_c('div',{staticClass:"component-loader-dot"})])}]

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{}!./node_modules/pug-plain-loader!../source/common/loader/loader.pug?vue&type=template&id=cec7f236&lang=pug&
// module id = 500
// module chunks = 1 5 6 7